const styles = theme => ({
  page__header__title: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',

    gap: 8,
    padding: '16px 24px',
    borderRadius: '16px',
    boxShadow:
      '0px 0px 2px 0px rgba(145, 158, 171, 0.12), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
  },
  inviteTexts: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
  },
  inviteLearners: {
    fontSize: '14px',
    fontWeight: 500,
  },
  inviteLearnersDescription: {
    fontSize: '14px',
    fontWeight: 400,
    color: '#637381',
  },
})

export default styles
